import { useState } from "react";
import { useSelector } from "react-redux";
import Input from "./generics/Input";
import {
  EMAIL_REGEX,
  getEmailSubscribeText,
  subscribeEmail,
} from "../utils/emailUtils";
import "../style/components/EmailSubscribe.css";

function EmailSubscribe() {
  const language = useSelector((state) => state.reducer.language);
  const text = getEmailSubscribeText(language);

  const [email, setEmail] = useState("");
  const [touched, setTouched] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const isValid = EMAIL_REGEX.test(email);
  const showError = touched && !isValid;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setTouched(true);
    if (!isValid) return;
    try {
      await subscribeEmail(email);
      setSubmitted(true);
    } catch (err) {}
  };

  if (submitted) {
    return (
      <div className="email-subscribe-form submitted">
        <div>
          <h3 className="email-subscribe-heading">{text.successHeading}</h3>
          <div className="body-b2 email-subscribe-subtext">
            {text.successSub}
          </div>
        </div>
      </div>
    );
  }

  return (
    <form className="email-subscribe-form">
      <div className="email-subscribe-text">
        <h3 className="email-subscribe-heading">{text.heading}</h3>
        <div className="body-b2 email-subscribe-subtext">{text.subText}</div>
      </div>
      <div className="email-subscribe-input">
        <Input
          name="email"
          value={email}
          error={showError}
          label={text.placeholder}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button
          className="email-subscribe-button custom-button-link"
          onClick={handleSubmit}
        >
          {text.submit}
        </button>
      </div>
    </form>
  );
}

export default EmailSubscribe;
